import { service } from '../../../helpers/http'

export const ActionFindTeacherWorkRegimeRules = ({ dispatch }, payload) => {

    return service({
        module: 'teacherWorkRegimeRule',
        action: 'find',
        payload: payload
    })

}

export const ActionCreateTeacherWorkRegimeRule = ({ dispatch }, payload) => {

    return service({
        module: 'teacherWorkRegimeRule',
        action: 'create',
        payload: payload
    })

}

export const ActionUpdateTeacherWorkRegimeRule = ({ dispatch }, payload) => {

    return service({
        module: 'teacherWorkRegimeRule',
        action: 'update',
        payload: payload
    })
}

export const ActionDeleteTeacherWorkRegimeRule = ({ dispatch }, payload) => {

    return service({
        module: 'teacherWorkRegimeRule',
        action: 'delete',
        payload: payload
    })

}
